/**
 * @author Rahul Nainala
 * @description 
 */
import axios from 'axios';
import { connect } from 'react-redux';
import { Select, Cascader } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import { LOGBOOK } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';

const { Option } = Select;
const newLocal = true;

const SelectComponent = (props) => {
  const { column, text, record, data, userProfile, handleFieldChange, handleKeyPress } = props;

  const [optionList, setOptionList] = useState([]);
  const [, setConditionList] = useState([]);

const getOptionList = useCallback(async (tableName,conditionList) => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let objectHeader = {};

    if (tableName.hierarchy) {
      setOptionList(userProfile?.belongsTo?.sites?.[siteId]?.hierarchy || []);
    } else if (!tableName.hierarchy) {
      if (Array.isArray(tableName.table)) {
        setOptionList(tableName.table);
        return tableName.table;
      }

      if (tableName.table?.url) {
        objectHeader = {
          method: tableName.table.method || 'POST',
          url: `${tableName.table.url}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          ...(tableName.table.method === 'POST' && {
            data: {
              ...tableName.table.payload,
              conditionList: conditionList || []
            }
          })
        };
      } else {
        objectHeader = {
          method: 'POST',
          url: `${LOGBOOK.DropDown}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            tableName: `master."${tableName.table}"`
          }
        };
      }


      try {
        const response = await axios(objectHeader);
        if (Array.isArray(response.data)) {
          setOptionList(response.data);
        }
      } catch {
        return [];
      }
    }
  }, [userProfile]);


  useEffect(() => {
    // let siteId = localStorage.get('currentSite');
    if (column &&
      props.datasource &&
      column.table &&
      column.table.payload &&
      column.table.payload.conditionList) {
      let conditionList = column.table.payload.conditionList;
      let dataSourceKeys = Object.keys(props.datasource);
      let subdataSourceKeys = props.subdatasource ? Object.keys(props.subdatasource) : [];

      conditionList.forEach((condition, key) => {
        if (condition.referenceKey) {
          if (dataSourceKeys.includes(condition.referenceKey)) {
            conditionList[key].value = props.datasource[condition.referenceKey];
          } else if (subdataSourceKeys.includes(condition.referenceKey)) {
            conditionList[key].value = props.subdatasource[condition.referenceKey];
          }
        }
      });
      setConditionList(conditionList);
      getOptionList(column, conditionList);
    } else {
      getOptionList(column);
    }
  }, [column, props.datasource, props.subdatasource, getOptionList]);


  useEffect(() => {
    let siteId = localStorage.get('currentSite');
    if (column.hierarchy) {
      setOptionList(userProfile?.belongsTo?.sites?.[siteId]?.hierarchy || []);
    } else if (Array.isArray(column.table)) {
      setOptionList(column.table);
    }
  }, [column, userProfile]);

  let selectedObject = [];
  if (column.autoPopulate && optionList && Array.isArray(optionList) && text) {
    selectedObject = optionList.filter(optionData => optionData.value.toString() === text.toString());
  } else if (column.checkOptions) {
    selectedObject = optionList.filter(optionData => optionData.value.toString() === text.toString());
  }

  let filterListed = [];
  if (column?.validation?.duplicate && !column.validation.conditionFilter) {
    if (Array.isArray(data)) {
      filterListed = data.map(da => da[column.key]);
    } else if (data && typeof data === 'object') {
      filterListed = Object.keys(data).map(da => data[da][column.key]);
    }
  } else if (column.validation?.conditionFilter && props.equipment) {
    let split = props.equipment.split(/[-]/);
    if (column.validation.conditionFilter[split[0]]) {
      if (Array.isArray(data)) {
        filterListed = data.map(da => da[column.key]);
      } else if (data && typeof data === 'object') {
        filterListed = Object.keys(data).map(da => data[da][column.key]);
      }
    }
  }

  if (column.hierarchy) {
    return (
      <Cascader
        options={optionList}
        showSearch
        value={text || undefined}
        style={{ width: 300 }}
        onChange={(e) => {
          if (e?.description) {
            handleFieldChange(e, column.key, record.key, e.description);
          } else if (e?.children) {
            handleFieldChange(e, column.key, record.key, e.children);
          } else {
            handleFieldChange(e, column.key, record.key);
          }
        }}
        onKeyPress={(e) => handleKeyPress(e, record.key)}
        placeholder={column.placeHolder || column.displayName}
        disabled={column.disable || false}
      />
    );
  } else {
    return (
      <Select
        showSearch
        value={text && selectedObject.length > 0 ? selectedObject[0].key : text}
        style={{
          width: 300,
          ...(props.status === 'Completed' ? {
            opacity: newLocal ? 0.75 : 1,
            pointerEvents: newLocal ? 'none' : 'initial'
          } : {})
        }}
        onChange={(e) => {
          if (column.autoPopulate) {
            handleFieldChange(e, column.key, record.key, record);
          } else if (column.autoPopulate === 'children') {
            handleFieldChange(e, column.key, record.key, e.children);
          } else if (column.autoNextValue) {
            let selectedData = optionList.find(optionData => optionData.value === e);
            handleFieldChange(e, column.key, record.key, selectedData);
          } else {
            handleFieldChange(e, column.key, record.key);
          }
        }}
        onKeyPress={(e) => handleKeyPress(e, record.key)}
        placeholder={column.placeHolder || column.displayName}
        disabled={column.disable || false}
        filterOption={(input, option) => {
          return option.props.children.toLowerCase().includes(input.toLowerCase());
        }}
      >
        {optionList.filter(col => {
          if (column?.validation?.duplicate) {
            if (col?.key && col?.value) {
              return !filterListed.includes(col.value);
            }
          }
          return !filterListed.includes(col);
        }).map((data, index) => (
          <Option key={index} value={data?.Value || data}>
            {data?.Key || data}
          </Option>
        ))}
      </Select>
    );
  }
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(SelectComponent);